import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import typo from '@blade-sxp/record-center/lang/index';
import { map } from 'lodash';
import colors from '@/styles/color.scss';
import { updateComment } from '@blade-sxp/record-center/api/portrait';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
let default_1 = class default_1 extends Vue {
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    tableData;
    filterAge = [];
    filterGender = [];
    union = require('@blade-sxp/task-management/assets/union.png');
    privacyMode = localStorage.getItem('privacyMode') || 'false';
    commentSelect = [
        {
            value: 'REMARK_CONFIRM_MATCH',
            label: this.$t('confirmMatched'),
        },
        {
            value: 'REMARK_IDENTIFICATION_ERROR',
            label: this.$t('confirmUnmatched'),
        },
        {
            value: 'REMARK_BLANK',
            label: '-',
        },
    ];
    commentValue = '';
    get formattedData() {
        return map(this.tableData, (item) => {
            const { name, age, status, ...rest } = item;
            const isFail = status === 'FAIL';
            return isFail
                ? {
                    name: name || '-',
                    age: age || '-',
                    status,
                    ...rest,
                }
                : item;
        });
    }
    get getTableBg() {
        return colors.colorBoxBg;
    }
    get setPrivacyMode() {
        return this.privacyMode === 'true' ? 6 : 0;
    }
    ageMap = {
        Adult: this.$t('Adult').toString(),
        Child: this.$t('Child').toString(),
        Elderly: this.$t('Elderly').toString(),
    };
    genderMap = {
        Male: this.$t('Male').toString(),
        Female: this.$t('Female').toString(),
    };
    initI18n() {
        this.filterAge = [
            { text: String(this.$t('Adult')), value: 'Adult' },
            { text: String(this.$t('Child')), value: 'Child' },
            { text: String(this.$t('Elderly')), value: 'Elderly' },
        ];
        this.filterGender = [
            { text: String(this.$t('Male')), value: 'Male' },
            { text: String(this.$t('Female')), value: 'Female' },
        ];
    }
    getSimilarity(val) {
        return val ? `${(val * 100).toFixed(2)}%` : '-';
    }
    changeRemark(val) {
        const params = {
            id: val.id,
            remark: val.remark,
        };
        try {
            updateComment(params)
                .then((res) => {
                const msg = this.$t('successMsg').toString();
                this.$message({ type: 'success', message: msg });
            })
                .finally(() => { });
        }
        catch (error) { }
    }
    filterTag(value) {
        if (value.age) {
            this.$emit('filterAge', value.age);
        }
        else if (value.gender) {
            this.$emit('filterGender', value.gender);
        }
    }
    getAgeVal(val) {
        return this.ageMap[val.age];
    }
    getGenderVal(val) {
        return this.genderMap[val.gender];
    }
    ellipsisName(str) {
        if (this.privacyMode === 'true') {
            return '******';
        }
        else {
            return str?.length > 10 ? str.slice(0, 10) + '...' : str;
        }
    }
    mounted() {
        this.initI18n();
    }
};
__decorate([
    Prop()
], default_1.prototype, "tableData", void 0);
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'portrait',
        components: { BlurPicture },
        i18n: {
            messages: {
                'en-us': {
                    name: 'Name',
                    age: 'Age',
                    comment: 'Comment',
                    idPicture: 'ID Photo',
                    liveImage: 'Live Image',
                    deviceName: 'Device Name',
                    suitability: 'Matched Score',
                    time: 'Recognized Time',
                    serialNumber: 'Device SN',
                    success: 'Success',
                    fail: 'Fail',
                    stranger: 'Stranger',
                    Adult: 'Adult',
                    Child: 'Child',
                    Elderly: 'Old',
                    gender: 'Gender',
                    Male: 'Male',
                    Female: 'Female',
                    recogResult: 'Result',
                    dbName: 'Portrait Library',
                    successMsg: 'Success',
                    icCard: 'IC Card',
                    unknown: 'Unkonwn',
                },
                zh: {
                    name: '姓名',
                    age: '年龄',
                    comment: '备注',
                    idPicture: '证件头像',
                    liveImage: '现场图像',
                    deviceName: '设备名称',
                    suitability: '匹配度',
                    time: '识别时间',
                    serialNumber: '设备序列号',
                    success: '识别成功',
                    fail: '识别失败',
                    stranger: '陌生人',
                    Adult: '成年人',
                    Child: '小孩',
                    Elderly: '老人',
                    gender: '性别',
                    Male: '男',
                    Female: '女',
                    recogResult: '识别结果',
                    dbName: '人像库',
                    successMsg: '操作成功',
                    icCard: 'IC卡',
                    unknown: '未知',
                },
            },
            sharedMessages: typo.messages,
        },
    })
], default_1);
export default default_1;
